export default __webpack_public_path__ + "static/desert-ca70d9a3859bb39d157ce4b56a360c5b.png";